<template>
  <div id="app" v-if="loaded">
    <main>
      <section id="contentPane" v-if="loaded">
        <transition :duration=1000 mode="out-in">
          <!-- router-view should be absolute for overlapsed transition layers with mode:out-in -->
          <router-view id="contentView" style="position:absolute; height: 100%; width: 100%;"></router-view>
        </transition>
      </section>
      <transition name="fade" mode="out-in" appear> 
        <section id="question" :key="overlay" v-if="overlay">
          <div class="content">
            <p>
              Möchtest du das Spiel wirklich beenden?<br/>
              Dein Fortschritt geht dann verloren.
            </p>
            <img src="../img/exit.svg" />
            <button v-on:click="showIntro()">Beenden</button>
            <button class="play" v-on:click="overlay = false">Spielen</button>
          </div>
        </section>
      </transition>
    </main>

    <standby id="standby" @goesStandby="goesStandby()" @awake="awake()"></standby>
    <transition name="fade" mode="out-in" appear> 
      <button id="close" :key="hasCloseButton" v-if="hasCloseButton" v-on:click="overlay = true">X</button>
    </transition>
  </div>       
</template>

<script>
import 'es6-promise/auto'
import axios from "axios";
import Vue from "Vue";
import Standby from "./Standby";
import Combinator from "./Combinator";
import eventBus from "../eventBus";

export default {
  name: "app",
  data() {
    return {
      loaded: false,
      hasCloseButton: false,
      overlay: false
    };
  },
  created() {
    console.log("Willentliches Vergessen App!");

    this.hasCloseButton = this.$route.path.indexOf("Game") >= 0 || (this.$route.path.indexOf("Intro") >= 0 && this.$route.params.page > 1);
    this.fetchData(() => (this.loaded = true));
  },
  components: {
    standby: Standby
  },
  watch: {
    $route(to, from) {
      this.hasCloseButton = this.$route.path.indexOf("Game") >= 0 || (this.$route.path.indexOf("Intro") >= 0 && this.$route.params.page > 1);
      eventBus.$emit("urlChanged");
    }
  },
  methods: {
    fetchData(callback) {
      /**
       * Loading config file.
       */
      axios
        .get(window.dataPath + "config.json")
        .then(response => {
          var d = response.data;
          window.isWeb = d.IsWeb;
          window.gameTime = d.GameTime;
          window.volume = d.Volume;
          window.combinationLength = d.CombinationLength;
          window.bonNames = d.BonNames;
          window.colors = d.Colors;
          window.keys = d.IsWeb ? d.Keys_Web : d.Keys;
          window.numDifferentBons = 6;
          window.iterationDepth = Math.min(window.bonNames.length, window.numDifferentBons);
          window.audios = [];
          for (var i = 0; i < 8; i++) {
            var path = window.dataPath + "audio/" + (i + 1) + ".mp3";
            window.audios.push(new Audio(path));
          }

          if (callback) callback();
        })
        .catch(error => console.log(error));
    },
    showIntro() {
      this.overlay = false;
      this.$router.replace({ path: "/Intro/1" });
      this.$nextTick(() => "");
    },
    goesStandby() {
      this.$router.replace({ path: "/" });
    },
    awake() {}
  }
};
</script>


<style lang="scss">
@import "../style/animate.css";
@import "../style/transitions.scss";
@import "../style/basic.scss";

html,
body {
  background-color: $grey;
  color: white;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  overflow: hidden;
  width: 100%;
  height: 100%;
  max-height: 100%;
  min-height: 100%;
  margin: 0;
  padding: 0;
  display: table;
  overflow: hidden;
}

#app {
  position: absolute;
  top: 50%;
  left: 50%;

  width: 100%;
  min-width: 760px;
  max-width: 1280px;

  height: 100%;
  min-height: 720px;
  max-height: 1024px;

  overflow: hidden;
  display: table;
  margin: 0 auto;
  transform: translate(-50%, -50%);
}

#contentView {
  width: 100%;
  max-width: 1280px;
  min-width: 760px;
  max-height: 1024px;
  min-height: 720px;
  position: absolute;
}

#close {
  position: absolute;
  top: 25px;
  left: calc(100% - 80px);
  width: 50px;
  max-width: 50px;
  min-width: 50px;
  line-height: 36px;
  height: 35px;
  padding-top: 1px;
  z-index: 10;
  transition: 1s all;
}

#question {
  position: absolute;
  max-width: 1280px;
  min-width: 760px;
  width: 100%;
  box-sizing: border-box;

  max-height: 1024px;
  min-height: 720px;
  height: 100%;

  overflow: hidden;
  display: table;
  margin: 0 auto;
  background: rgba(102, 101, 101, 0.9);
  z-index: 11;

  .content {
    width: 500px;
    margin: 0 auto;
    margin-top: 40%;
    transform: translateY(-50%);

    p {
      text-align: center;
      font-size: 24px;
    }

    img {
      margin: 0 auto;
      margin-bottom: 25px;
      margin-top: 25px;
      margin-left: (400px - 341px) * 0.5;
      margin-right: (400px - 341px) * 0.5;
    }

    button {
      margin-left: 25px;

      &:first-of-type {
        margin-left: 85px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/WillentlichesVergessenApp.vue